export default __webpack_public_path__ + "static/bZLyQxZI-504692f0f09c3fe396344ee04ac8ace9.svg";